import { useEffect } from 'react'

/** Sets the tab title. Never includes customer data — a tab title reaches */
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    document.title = `${title} · Paisa24 Control Panel`
  }, [title])
}
